import { Delegate } from '../delegate'
import { File } from '../file'
import { Topic } from '../topic'

class PopulateTopic extends Topic {
  constructor(options = {}) {
    options = options || {}
    super(options)
    this.allowRecord = options.allowRecord
    this.consent = options.consent
    this.date = options.date
    this.eventShortCode = options.eventShortCode
    this.files = File.initOnlyValidFromArray(options.files)
    this.newVersion = options.newVersion || false
    this.note = options.note
    this.questionDuration = options.questionDuration || 0
    this.sessionCode = options.sessionCode
    this.speaker = Delegate.init(options.speaker)
    this.topicId = options.topicId
    this.uploadedTime = options.uploadedTime
  }

  // Class methods
  static init(options) {
    if (options instanceof PopulateTopic) {
      return options
    }
    const instance = new PopulateTopic(options)
    return instance.isValid ? instance : null
  }
  static initFromArray(arr) {
    if (Array.isArray(arr)) {
      return arr.map(this.init)
    }
    return []
  }
  static initOnlyValidFromArray(arr = []) {
    return this.initFromArray(arr).filter((i) => i)
  }

  // getters
  get isValid() {
    return super.isValid && !!this.name
  }
  get $endTime() {
    const date = (this.date || '').replace(/-/g, '/')
    return new Date(`${date} ${this.endTime}`)
  }
  get $startTime() {
    const date = (this.date || '').replace(/-/g, '/')
    return new Date(`${date} ${this.startTime}`)
  }

  get hasUploadedFile() {
    return this.files.find((file) => {
      return !!file.isUploaded
    })
  }
}

export default {
  PopulateTopic
}
export {
  PopulateTopic
}
